import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import BusinessIcon from '@mui/icons-material/Business';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import { List, ListItem, ListItemIcon, ListItemText, Typography} from '@mui/material';


export default function Contact() {
    return (
        <>
            
            <Divider sx={{mb: 10, height: 1, width: 800, backgroundColor: '#ffd700'}}></Divider>

            
            <Typography variant='h3' sx={{mb:2}}>Contact</Typography>
            <List>
                <ListItem>
                    <ListItemIcon sx={{color: '#ffffff'}}><MailOutlineIcon/></ListItemIcon>
                    <ListItemText><strong> Email: </strong> dlzventuresllc@gmail.com</ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon sx={{color: '#ffffff'}}><PhoneAndroidOutlinedIcon/></ListItemIcon>
                    <ListItemText><strong> Phone: </strong> (959) 895-7738</ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon sx={{color: '#ffffff'}}><BusinessIcon/></ListItemIcon>
                    <ListItemText><strong> Address: </strong> 25 Outlook Ave, West Hartford, CT 06119</ListItemText>
                </ListItem>
            </List>
            

            <Divider sx={{mt: 10, mb: 2, height: 1, width: 800, backgroundColor: '#ffd700'}}></Divider>


            <footer>
                <small>© {new Date().getFullYear()} DLZ Ventures LLC</small>
            </footer>
            <Box sx={{ mt: 2, flexGrow: 1 , width: '100%'}}><Paper sx={{height:50, backgroundColor: '#000000'}}/></Box>

        </>
    )
  }